module.exports = __webpack_public_path__ + "static/favicon-786683769f94181d602dda423028f721.ico";